export default "__VITE_ASSET__AWd3S4rM__"